import axios from "axios";

// Use a same-origin relative base path so the app works on every hostname the
// site is served on (preview URL, default production URL and any custom
// domain such as program.roedtbergen.no). Emergent's ingress routes /api/*
// to the FastAPI backend regardless of the host header, which also keeps the
// httpOnly admin-session cookie scoped to the current domain — no CORS, no
// cross-site cookie issues.
export const API = "/api";

const api = axios.create({ baseURL: API, withCredentials: true });

export default api;

export const fetchMeta = () => api.get("/meta").then((r) => r.data);
export const fetchPrograms = (params) => api.get("/programs", { params }).then((r) => r.data);
export const fetchProgram = (id) => api.get(`/programs/${id}`).then((r) => r.data);
export const searchPrograms = (params) => api.get("/search", { params }).then((r) => r.data);

export const adminLogin = (password) => api.post("/admin/login", { password }).then((r) => r.data);
export const adminLogout = () => api.post("/admin/logout").then((r) => r.data);
export const adminMe = () => api.get("/admin/me").then((r) => r.data);
export const adminListPrograms = () => api.get("/admin/programs").then((r) => r.data);
export const adminProgramStatus = (id) =>
    api.get(`/admin/programs/${id}/status`).then((r) => r.data);
export const adminDelete = (id) => api.delete(`/admin/programs/${id}`).then((r) => r.data);
export const adminUpload = (formData) =>
    api
        .post("/admin/programs/upload", formData, {
            headers: { "Content-Type": "multipart/form-data" },
            timeout: 120000,
        })
        .then((r) => r.data);
